import $ from 'jquery';
import WOW from 'wowjs';

export default function () {
	new WOW.WOW().init();
}